import React from 'react';
import { Button } from '@chakra-ui/react';

interface PaginationItemProps {
  number: number;
  isCurrent?: boolean;
  onPageChange: (page: number) => void;
}

export const PaginationItem: React.VFC<PaginationItemProps> = ({
  isCurrent = false,
  number,
  onPageChange,
}) => {
  if (isCurrent) {
    return (
      <Button
        size="sm"
        fontSize="xs"
        w="4"
        _hover={{
          background: 'black',
        }}
        disabled
        _disabled={{
          bg: 'gray.900',
          color: 'white',
          cursor: 'default',
        }}
      >
        {number}
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      fontSize="xs"
      w="4"
      bg="gray.300"
      color="gray.900"
      _hover={{
        bg: 'gray.300',
      }}
      onClick={() => onPageChange(number)}
    >
      {number}
    </Button>
  );
};
